module.exports = __webpack_public_path__ + "img/cockpit-horizontal_bg.fc3a8bb9.png";